// forms[0] for quantity 1 - przykład
// forms[1] for quantity 2 - przykłady
// forms[2] for quantity 5 - przykładów
export const pluralize =
    (forms: [string, string, string]) =>
    (n: number): string =>
        forms[getFormIndex(n)];

export const whichPluralize = pluralize(["którą", "które", "które"]);
export const promotionOfferPluralize = pluralize(["oferta promocyjna", "oferty promocyjne", "ofert promocyjnych"]);
export const promotionVerbPluralize = pluralize(["czeka", "czekają", "czeka"]);
export const isLocatedPluralize = pluralize(["znajduje", "znajdują", "znajduje"]);
export const metCriteriaPluralize = pluralize(["spełniało", "spełniały", "spełniały"]);

export const investmentOffer = {
    locative: pluralize(["inwestycji", "inwestycjach", "inwestycjach"]),
    accusative: pluralize(["inwestycję", "inwestycje", "inwestycji"])
};

export const propertyOffer = {
    nominative: pluralize(["oferta", "oferty", "ofert"]),
    accusative: pluralize(["ofertę", "oferty", "ofert"])
};

export const investment = {
    nominative: pluralize(["inwestycja", "inwestycje", "inwestycji"])
};

export const property = {
    nominative: pluralize(["nieruchomość", "nieruchomości", "nieruchomości"])
};

export const flat = {
    nominative: pluralize(["mieszkanie", "mieszkania", "mieszkań"])
};

export const apartment = {
    nominative: pluralize(["apartament", "apartamenty", "apartamentów"])
};

export const house = {
    nominative: pluralize(["dom", "domy", "domów"])
};

export const commercial = {
    nominative: pluralize(["lokal", "lokale", "lokali"])
};

export const modularHouse = {
    nominative: pluralize(["dom modułowy", "domy modułowe", "domów modułowych"])
};

export const housingEstate = {
    nominative: pluralize(["osiedle", "osiedla", "osiedli"])
};

export const submission = {
    nominative: pluralize(["zgłoszenie", "zgłoszenia", "zgłoszeń"])
};

export const level = {
    nominative: pluralize(["poziom", "poziomy", "poziomów"])
};

function getFormIndex(n: number): 0 | 1 | 2 {
    if (n === 1) {
        return 0; // quantity 1
    }

    if (10 <= n % 100 && n % 100 < 20) {
        // teen-odd = 1x
        return 2; // quantity 5
    }

    if (n % 10 < 2) {
        // x0, x1
        return 2; // quantity 5
    }

    if (n % 10 > 4) {
        // x5, x6, x7, x8, x9
        return 2; // quantity 5
    }

    return 1; // quantity 2
}
// forms[0] for quantity 1 - przykład
// forms[1] for quantity 2 - przykłady
// forms[2] for quantity 5 - przykładów
export const pluralize =
    (forms: [string, string, string]) =>
    (n: number): string =>
        forms[getFormIndex(n)];

export const whichPluralize = pluralize(["którą", "które", "które"]);
export const promotionOfferPluralize = pluralize(["oferta promocyjna", "oferty promocyjne", "ofert promocyjnych"]);
export const promotionVerbPluralize = pluralize(["czeka", "czekają", "czeka"]);
export const isLocatedPluralize = pluralize(["znajduje", "znajdują", "znajduje"]);
export const metCriteriaPluralize = pluralize(["spełniało", "spełniały", "spełniały"]);

export const investmentOffer = {
    locative: pluralize(["inwestycji", "inwestycjach", "inwestycjach"]),
    accusative: pluralize(["inwestycję", "inwestycje", "inwestycji"])
};

export const propertyOffer = {
    nominative: pluralize(["oferta", "oferty", "ofert"]),
    accusative: pluralize(["ofertę", "oferty", "ofert"])
};

export const investment = {
    nominative: pluralize(["inwestycja", "inwestycje", "inwestycji"])
};

export const property = {
    nominative: pluralize(["nieruchomość", "nieruchomości", "nieruchomości"])
};

export const flat = {
    nominative: pluralize(["mieszkanie", "mieszkania", "mieszkań"])
};

export const apartment = {
    nominative: pluralize(["apartament", "apartamenty", "apartamentów"])
};

export const house = {
    nominative: pluralize(["dom", "domy", "domów"])
};

export const commercial = {
    nominative: pluralize(["lokal", "lokale", "lokali"])
};

export const modularHouse = {
    nominative: pluralize(["dom modułowy", "domy modułowe", "domów modułowych"])
};

export const housingEstate = {
    nominative: pluralize(["osiedle", "osiedla", "osiedli"])
};

export const submission = {
    nominative: pluralize(["zgłoszenie", "zgłoszenia", "zgłoszeń"])
};

export const level = {
    nominative: pluralize(["poziom", "poziomy", "poziomów"])
};

function getFormIndex(n: number): 0 | 1 | 2 {
    if (n === 1) {
        return 0; // quantity 1
    }

    if (10 <= n % 100 && n % 100 < 20) {
        // teen-odd = 1x
        return 2; // quantity 5
    }

    if (n % 10 < 2) {
        // x0, x1
        return 2; // quantity 5
    }

    if (n % 10 > 4) {
        // x5, x6, x7, x8, x9
        return 2; // quantity 5
    }

    return 1; // quantity 2
}
